import { render, staticRenderFns } from "./PointStatistical.vue?vue&type=template&id=4da405f3&"
import script from "./PointStatistical.vue?vue&type=script&lang=js&"
export * from "./PointStatistical.vue?vue&type=script&lang=js&"
import style0 from "./PointStatistical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports